// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__robotoBoldItalic_cae4cd', '__robotoBoldItalic_Fallback_cae4cd'","fontWeight":700},"className":"__className_cae4cd","variable":"__variable_cae4cd"};